import type { TranslationCatalog } from "../TranslationManager";

export const ar: TranslationCatalog = {
  "labels.cardNumber": "رقم البطاقة",
  "labels.expirationDate": "تاريخ انتهاء الصلاحية",
  "labels.cvc": "رمز الأمان",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / YY",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "رقم بطاقتك غير صالح.",
  "errors.invalidExpiryDate": "تاريخ انتهاء صلاحية بطاقتك غير صالح.",
  "errors.invalidCvc": "رمز الأمان الخاص ببطاقتك غير صالح.",
  "errors.incompleteCardNumber": "رقم بطاقتك غير مكتمل.",
  "errors.incompleteExpiryDate": "تاريخ انتهاء صلاحية بطاقتك غير مكتمل.",
  "errors.incompleteCvc": "رمز الأمان الخاص ببطاقتك غير مكتمل.",
  "errors.expiredCard": "بطاقتك منتهية الصلاحية.",
  "aria.cardNumber": "رقم البطاقة",
  "aria.expirationDate": "تاريخ انتهاء الصلاحية",
  "aria.cvc": "رمز الأمان",
  "aria.cardInput": "معلومات البطاقة",
};
